import { SERIE_FORMAT } from "@tokenterminal/core/feature/chart/ChartOptions"

export { POSSIBLE_METRICS_ENUM } from "../data/metric-configuration"

export { SERIE_FORMAT as METRIC_FORMAT }

export const metricAliasesById: Record<string, string[]> = {
  tvl: ["tvl"],
  market_cap_fully_diluted: ["fdv", "market cap"],
}
